import React from 'react';
import './SectionBody.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const SectionBody = () => {
  return (
    <section className="section-body-carousel">
      <h2 className="section-title">WHY ALTORACAPITAL?</h2>
      <div className="carousel-container1">
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          spaceBetween={30}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop
        >
          {/* Slide 1: Security */}
          <SwiperSlide>
            <div className="section-row">
              <div className="section-col section-col-left">
                <div className="section-partners">
                  <button className="partner-btn fireblocks">Fireblocks</button>
                  <button className="partner-btn chainalysis">Chainalysis</button>
                  <img src="/blofin/iso.png" alt="ISO" className="partner-iso" />
                </div>
                <div className="section-highlight orange">
                  <div className="highlight-text">
                    <h3>YOUR ASSETS, YOUR PRIVACY PROTECTED BY MULTI-LAYER SECURITY</h3>
                    <p>Top-tier partners. Top-level asset protection.</p>
                  </div>
                  <img src="/blofin/keys.5a67cb91.png" alt="Keys" className="highlight-img" />
                </div>
              </div>
              <div className="section-col section-col-right">
                <img src="/blofin/whyus.02a521f7.png" alt="Security" className="security-img" />
              </div>
            </div>
          </SwiperSlide>
          {/* Slide 2: High-Performance Trading */}
          <SwiperSlide>
            <div className="section-row">
              <div className="section-col section-col-left">
                <div className="section-highlight dark">
                  <div className="highlight-text">
                    <h3 className='text-white'>FAST, SEAMLESS, 360° HIGH-PERFORMANCE TRADING</h3>
                    <p className='text-white'>Your Whale Move Starts Here.</p>
                  </div>
                  <img src="/blofin/task.png" alt="Trading" className="highlight-img" />
                </div>
                <div className="section-highlight orange">
                  <div className="highlight-text">
                    <h3>TOP-TIER SYSTEM SPEED</h3>
                  </div>
                  <img src="/blofin/whyme1.a991f024.png" alt="Speed" className="highlight-img" />
                </div>
              </div>
              <div className="section-col section-col-right orange-bg">
                <img src="/blofin/whyme2.webp" alt="Performance" className="security-img" />
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default SectionBody;
